module.exports = __webpack_public_path__ + "img/label-mc-bb1.5d36e244.png";